import { useState } from "react";
import { Link } from "react-router-dom";
import { assetUrl } from "../asset-url";
const moduleMeta = [
  { label: "Design", detail: "AI-guided discovery and sequence design" },
  { label: "Build", detail: "Mb-scale DNA synthesis from scratch" },
  { label: "Measure", detail: "High-content assays and multi-omic evidence" },
  { label: "Translate", detail: "Governed execution and real-world delivery" },
];

export default function PlatformObservatory({ modules }) {
  const [activeModuleIndex, setActiveModuleIndex] = useState(0);
  const activeModule = modules[activeModuleIndex];
  const activeMeta = moduleMeta[activeModuleIndex];

  return (
    <div className="platform-observatory" aria-label="Medein platform modules">
      <img
        className="observatory-field"
        src={assetUrl("/assets/generated/medein-observatory-overlay.webp")}
        width="1536"
        height="1024"
        alt=""
        loading="eager"
        fetchPriority="high"
        decoding="async"
      />

      <div className="observatory-core">
        <img src={assetUrl("/assets/science_icon_svg_019_signal_bars.svg")} alt="" />
        <strong>Medein</strong>
        <span>Integrated platform</span>
      </div>

      <ol className="observatory-modules">
        {modules.map((module, index) => {
          const meta = moduleMeta[index];
          return (
            <li className={`observatory-module observatory-module-${index + 1}`} key={module.slug}>
              <Link to={`/platform/${module.slug}`} aria-label={`${meta.label}: ${meta.detail}`}>
                <span className="observatory-icon"><img src={module.icon} alt="" /></span>
                <span className="observatory-copy">
                  <strong>{meta.label}</strong>
                  <span>{meta.detail}</span>
                </span>
              </Link>
            </li>
          );
        })}
      </ol>
      <p className="observatory-note"><i aria-hidden="true" /> illustrative map · select a module to explore</p>

      <div className="observatory-mobile">
        <p className="observatory-mobile-label">Integrated platform</p>
        <div className="observatory-mobile-tabs" role="tablist" aria-label="Explore Medein platform modules">
          {modules.map((module, index) => (
            <button
              className={activeModuleIndex === index ? "is-active" : ""}
              id={`mobile-platform-tab-${index}`}
              key={module.slug}
              type="button"
              role="tab"
              aria-selected={activeModuleIndex === index}
              aria-controls="mobile-platform-panel"
              tabIndex={activeModuleIndex === index ? 0 : -1}
              onClick={() => setActiveModuleIndex(index)}
            >
              <span><img src={module.icon} alt="" /></span>
              <strong>{moduleMeta[index].label}</strong>
            </button>
          ))}
        </div>

        <article
          className="observatory-mobile-focus"
          id="mobile-platform-panel"
          role="tabpanel"
          aria-labelledby={`mobile-platform-tab-${activeModuleIndex}`}
          aria-live="polite"
        >
          <img
            src={assetUrl("/assets/generated/medein-observatory-overlay.webp")}
            alt=""
            width="1536"
            height="1024"
            decoding="async"
          />
          <div>
            <span>{String(activeModuleIndex + 1).padStart(2, "0")} / {String(modules.length).padStart(2, "0")}</span>
            <strong>{activeMeta.label}</strong>
            <p>{activeMeta.detail}</p>
            <Link to={`/platform/${activeModule.slug}`}>Explore {activeMeta.label}</Link>
          </div>
        </article>
      </div>
    </div>
  );
}
